import { createFileRoute } from "@tanstack/react-router";
import { useOrganization } from "@/lib/auth";
import { PageChrome } from "@/components/chrome/PageChrome";
import { InviteMemberDialog } from "@/components/settings/members/InviteMemberDialog";
import { SeatLimitBanner } from "@/components/settings/members/SeatLimitBanner";
import { MembersPanel } from "@/components/settings/members/MembersPanel";

export const Route = createFileRoute("/settings/members")({
  component: MembersPage,
});

function MembersPage() {
  const { organization } = useOrganization();
  const orgName = organization?.name ?? "";

  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      <PageChrome
        crumbs={[
          { label: orgName || "Org", to: "/dashboard" },
          { label: "Settings" },
          { label: "Members" },
        ]}
        title="Members"
        helper="People with access to this workspace, their roles, and pending invites."
        actions={<InviteMemberDialog />}
      />
      <div className="flex-1 overflow-auto px-4 sm:px-7 py-6">
        <div className="flex flex-col gap-5">
          <SeatLimitBanner />
          <MembersPanel />
        </div>
      </div>
    </div>
  );
}
